import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import DisclosureGuidelineClimateChangeStructure from '@Router/EsgGreenhouse/Components/DisclosureGuidlineClimateChangeStructure';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import ClimateChangeStructureBoardDirector from './ClimateChangeStructureBoardDirector/ClimateChangeStructureBoardDirector';
import ClimateChangeStructureCheckbox from './ClimateChangeStructureCheckbox';
import ClimateChangeStructureCompletedCheckbox from './ClimateChangeStructureCompletedCheckbox';
import ClimateChangeStructureIntroduction, {
  CLIMATE_CHANGE_STRUCTURE_INTRODUCTION_ID,
} from './ClimateChangeStructureIntroduction';
import ClimateChangeStructureRemark, {
  CLIMATE_CHANGE_STRUCTURE_REMARK_ID,
} from './ClimateChangeStructureRemark';
import ClimateChangeStructureSubcommittee from './ClimateChangeStructureSubcommittee/ClimateChangeStructureSubcommittee';
import { ICommitteeTypeFormValues } from '../EsgGreenhouseFormProvider/types';

const ClimateChangeStructure = () => {
  const { watch } = useGreenhouseForm();
  const committee = watch(
    'climateChangeStructure.committee'
  ) as ICommitteeTypeFormValues;
  const { boardResponsibility, subcommitteeResponsibility } = committee || {};

  return (
    <Box bgcolor="white">
      <Box p={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1} alignItems={'center'}>
            <Typography fontWeight={'bold'}>
              กำหนดโครงสร้างการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ
            </Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <ClimateChangeStructureIntroduction />
              <ClimateChangeStructureRemark />
            </Flex>
          </Flex>
          <DisclosureGuidelineClimateChangeStructure />
        </Flex>
        <Box id={CLIMATE_CHANGE_STRUCTURE_INTRODUCTION_ID} />
        <Box id={CLIMATE_CHANGE_STRUCTURE_REMARK_ID} />
        <ClimateChangeStructureCheckbox />
        {boardResponsibility && <ClimateChangeStructureBoardDirector />}
        {subcommitteeResponsibility && <ClimateChangeStructureSubcommittee />}
      </Box>
      <ClimateChangeStructureCompletedCheckbox />
    </Box>
  );
};

export default ClimateChangeStructure;
